import"core-js/modules/es.regexp.exec.js";import"core-js/modules/es.string.match.js";import"core-js/modules/es.array.join.js";/**
 *
 * @param phoneNumber
 * @returns {boolean} - returns true for number that starts with '+' and contains a mix of digits and spaces with
 * at least 4 digits.
 */export var isValidPhoneNumber=function(a){return /^\+[\d-\s]+$/.test(a)&&a.match(/\d+/g)&&4<=a.match(/\d+/g).join("").length};